import { useSuspenseQuery } from '@tanstack/react-query';
import { queryKey } from '../../../constant/queryKey';
import { homeService } from 'shared/src/api';

export const useHomeTabs = () => {
  return useSuspenseQuery({
    queryKey: queryKey.homeTabs(),
    queryFn: () => homeService.getHomeTabs(),
  });
};
